import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import useDebounce from '../../hooks/useDebounce';
import {changeField, initialize, readFeedbackList, updateComment} from '../../modules/admin/feedback';
import FeedbackList from '../../components/admin/feedback/FeedbackList';
import DetailTemplate from '../../components/admin/feedback/DetailTemplate';

export default function FeedbackListContainer() {
    const dispatch = useDispatch();

    const { f_type, state, s_type, start_date, end_date, employee, content, page, listResponse, listErrorResponse, pagination, listLoading, detailResponse, detailErrorResponse, detailLoading, updateResponse, updateErrorResponse, updateLoading } = useSelector(({ adminFeedback, loading }) => ({
        f_type: adminFeedback.f_type,
        state: adminFeedback.state,
        s_type: adminFeedback.s_type,
        start_date: adminFeedback.start_date,
        end_date: adminFeedback.end_date,
        employee: adminFeedback.employee,
        content: adminFeedback.content,
        page: adminFeedback.page,
        listResponse: adminFeedback.listResponse,
        listErrorResponse: adminFeedback.listErrorResponse,
        pagination: adminFeedback.pagination,
        listLoading: loading['adminFeedback/READ_FEEDBACK_LIST'],
        detailResponse: adminFeedback.detailResponse,
        detailErrorResponse: adminFeedback.detailErrorResponse,
        detailLoading: loading['adminFeedback/READ_FEEDBACK_DETAIL'],
        updateResponse: adminFeedback.updateResponse,
        updateErrorResponse: adminFeedback.updateErrorResponse,
        updateLoading: loading['adminFeedback/UPDATE_COMMENT']
    }));

    const debouncedEmployee = useDebounce(employee, 1000);

    const handleChange = (e) => {
        const { name, value } = e.target;
        dispatch(changeField({ name, value }));
    };

    const handleUpdateComment = ({ id, type, adminComment, userComment }) => {
        dispatch(updateComment({ id, type, adminComment, userComment }));
    };

    useEffect(() => {
        dispatch(initialize());
    }, []);

    useEffect(() => {
        dispatch(readFeedbackList({
            f_type,
            state,
            s_type,
            start_date,
            end_date,
            employee: debouncedEmployee ? debouncedEmployee.trim() : null,
            content,
            page
        }));
    }, [f_type, state, s_type, start_date, end_date, debouncedEmployee, content, page]);

    return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            <FeedbackList
                f_type={f_type}
                state={state}
                s_type={s_type}
                start_date={start_date}
                end_date={end_date}
                employee={employee}
                content={content}
                listResponse={listResponse}
                listErrorResponse={listErrorResponse}
                listLoading={listLoading}
                pagination={pagination}
                handleChange={handleChange}
            />
            <DetailTemplate
                detailResponse={detailResponse}
                detailErrorResponse={detailErrorResponse}
                detailLoading={detailLoading}
                updateResponse={updateResponse}
                updateErrorResponse={updateErrorResponse}
                updateLoading={updateLoading}
                handleUpdateComment={handleUpdateComment}
            />
        </div>
    );
}
